import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5d3aeed4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-grid" }
const _hoisted_2 = { class: "members-column" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "underline" }, "Current members", -1))
const _hoisted_4 = { class: "search-input" }
const _hoisted_5 = { class: "margin-top" }
const _hoisted_6 = {
  class: "members-list",
  "data-test": "egm-members-list"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "row"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_10 = { class: "col-sm-12" }
const _hoisted_11 = {
  class: "text-danger text-left",
  "data-test": "egm-errors"
}
const _hoisted_12 = { class: "add-members-column" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "underline" }, "Add more members", -1))
const _hoisted_14 = ["disabled"]

import { Modal } from "uiv";
import { computed, ref } from "vue";
import {
  EditGroupMembersApiModel,
  ResultApiModel,
  ShortUserDetailsApiModel,
} from "../../../api-models";
import { csContext } from "../../../services/cs-context";
import { HttpMethods, useAxios } from "../../../composables/api";
import SearchUsers from "./accredited-user-area-search-users.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'accredited-user-area-edit-group-members-modal',
  props: {
    showEditMembers: { type: Boolean },
    existingMembers: {},
    teamId: {},
    teamName: {},
    organizationId: {}
  },
  emits: ["update:showEditMembers"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const searchMembersText = ref("");
const memberList = ref<ShortUserDetailsApiModel[]>(props.existingMembers);
const editedUsers = ref<ShortUserDetailsApiModel[]>([]);
const isLoading = ref(false);
const isSaving = ref(false);
const errorText = ref<string | null>(null);

const shown = computed({
  get: () => props.showEditMembers,
  set: (value) => emit("update:showEditMembers", value),
});

const filteredMembers = computed(() => {
  const searchQuery = searchMembersText.value.toLowerCase().trim();
  return memberList.value.filter((m) => {
    return (
      m.firstName.toLowerCase().includes(searchQuery) ||
      m.lastName.toLowerCase().includes(searchQuery)
    );
  });
});

const close = (): void => {
  let isRefreshNeeded = false;
  if (editedUsers.value.length) {
    isRefreshNeeded = true;
  }
  emit("update:showEditMembers", isRefreshNeeded);
};

const submitEditGroupMembers = (updatedMembers: ShortUserDetailsApiModel[]): void => {
  errorText.value = null;
  isSaving.value = true;
  const ids = updatedMembers.map((m) => {
    return m.id;
  });
  const groupEditModel: EditGroupMembersApiModel = {
    memberIds: ids,
    triggeringUserId: csContext.user.id,
  };
  const { data, errorStatus, promise } = useAxios<ResultApiModel>(
    `/api/accrediteduserarea/editmembers/${props.teamId}`,
    {
      isFatal: false,
      httpMethod: "POST" as HttpMethods,
      data: groupEditModel,
    },
  );
  promise.then(() => {
    if (errorStatus.value) {
      errorText.value = "There was a problem editing the group members";
    }

    isSaving.value = false;

    if (data.value?.success) {
      close();
    }
  });
};

const hasUserAlreadyBeenEdited = (member: ShortUserDetailsApiModel): boolean => {
  return (
    editedUsers.value.filter((u) => {
      return u.id === member.id;
    }).length > 0
  );
};

const removeMember = (id: string): void => {
  const updatedMembers = memberList.value.filter((m) => {
    return m.id !== id;
  });
  const memberToRemoveFromTeam = memberList.value.find((m) => {
    return m.id === id;
  }) as ShortUserDetailsApiModel;

  memberList.value = updatedMembers;

  if (hasUserAlreadyBeenEdited(memberToRemoveFromTeam)) {
    editedUsers.value = editedUsers.value.filter((u) => {
      return u.id !== memberToRemoveFromTeam.id;
    });
  } else {
    editedUsers.value.push(memberToRemoveFromTeam);
  }
};

const addMember = (member: ShortUserDetailsApiModel): void => {
  const updatedMembers = memberList.value;
  updatedMembers.push(member);

  memberList.value = updatedMembers;

  if (hasUserAlreadyBeenEdited(member)) {
    editedUsers.value = editedUsers.value.filter((u) => {
      return u.id !== member.id;
    });
  } else {
    editedUsers.value.push(member);
  }
};

const getMemberFullName = (member: ShortUserDetailsApiModel): string => {
  return `${member.firstName} ${member.lastName}`;
};

const updateSearchState = (isSearching: boolean): void => {
  isLoading.value = isSearching;
};

return (_ctx: any,_cache: any) => {
  return (shown.value)
    ? (_openBlock(), _createBlock(_unref(Modal), {
        key: 0,
        modelValue: shown.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((shown).value = $event)),
        title: _ctx.teamName,
        "data-test": "egm-modal"
      }, {
        footer: _withCtx(() => [
          _createElementVNode("button", {
            class: "btn btn-default",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (close())),
            "data-test": "egm-close-modal"
          }, "Close"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            disabled: !editedUsers.value.length || isSaving.value || isLoading.value,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (submitEditGroupMembers(memberList.value))),
            "data-test": "egm-edit-group-members"
          }, _toDisplayString(isSaving.value ? "Saving..." : "Confirm"), 9, _hoisted_14)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _withDirectives(_createElementVNode("input", {
                  type: "search",
                  class: "form-control",
                  placeholder: "Search members...",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchMembersText).value = $event)),
                  "data-test": "egm-search-members"
                }, null, 512), [
                  [_vModelText, searchMembersText.value]
                ])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("ul", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMembers.value, (member) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: member.id
                    }, [
                      _createElementVNode("button", {
                        class: "btn btn-default-close justify-left",
                        style: {"width":"100%"},
                        onClick: ($event: any) => (removeMember(member.id)),
                        "data-test": "egm-member-button"
                      }, _toDisplayString(getMemberFullName(member)), 9, _hoisted_7)
                    ]))
                  }), 128))
                ])
              ]),
              (errorText.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("p", _hoisted_11, _toDisplayString(errorText.value), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(SearchUsers, {
                existingMembers: memberList.value,
                organizationId: _ctx.organizationId,
                onSelectUser: addMember,
                onUpdateSearchState: updateSearchState
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              }, 8, ["existingMembers", "organizationId"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "title"]))
    : _createCommentVNode("", true)
}
}

})